import { StateScheme } from 'app/providers/StoreProvider/config/StateScheme'

export const getChartReleaseStore = (state: StateScheme) => {
    return state.statistics.chartReleasesStore
}
